import React, { useState, useEffect } from 'react';
import './index.css';

const Loader = () => {


  return (
    <div className="loader-overlay">
      <div className="loader">
        <div className="spinner"></div>
      </div>
    </div>
  );
};

export default Loader;



